import React from "react";
import { View, Text, StyleSheet, Pressable, Dimensions } from "react-native";
import { Button, IconButton } from "react-native-paper";
import { Ionicons } from "@expo/vector-icons";

interface TimeWarningModalProps {
  visible: boolean;
  onClose: () => void;
}

export default function TimeWarningModal({
  visible,
  onClose,
}: TimeWarningModalProps) {
  if (!visible) return null;

  return (
    <View style={styles.root}>
      <Pressable style={styles.backdrop} onPress={onClose} />

      {/* Centered card */}
      <View style={styles.centered}>
        <View style={styles.card}>
          <View style={styles.header}>
            <IconButton
              icon="close"
              size={20}
              onPress={onClose}
              accessibilityLabel="Close"
            />
          </View>

          <View style={styles.content}>
            <View style={styles.iconContainer}>
              <Ionicons name="time" size={48} color="#ff6b35" />
            </View>

            <Text style={styles.warningText}>Meeting will end in</Text>
            <Text style={styles.timeText}>2 MINUTES</Text>
            <Text style={styles.descriptionText}>
              The meeting will automatically end in 2 minutes
            </Text>
          </View>

          <View style={styles.actions}>
            <Button
              mode="contained"
              onPress={onClose}
              buttonColor="#ff6b35"
              textColor="#fff"
              style={styles.button}
              labelStyle={styles.buttonText}
            >
              Got it
            </Button>
          </View>
        </View>
      </View>
    </View>
  );
}

const { height: screenHeight } = Dimensions.get("window");

const styles = StyleSheet.create({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: "transparent",
  },
  backdrop: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  centered: {
    flex: 1,
    justifyContent: "center",
    paddingHorizontal: 16,
  },
  card: {
    backgroundColor: "white",
    borderRadius: 16,
    padding: 16,
    elevation: 6,
    maxHeight: screenHeight * 0.6,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 16,
  },
  title: {
    fontSize: 18,
    fontWeight: "700",
    color: "#ff6b35",
  },
  content: {
    alignItems: "center",
    marginBottom: 24,
  },
  iconContainer: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: "#fff5f5",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 16,
  },
  warningText: {
    fontSize: 16,
    color: "#333",
    textAlign: "center",
    marginBottom: 8,
  },
  timeText: {
    fontSize: 28,
    fontWeight: "bold",
    color: "#ff6b35",
    textAlign: "center",
    marginBottom: 8,
  },
  descriptionText: {
    fontSize: 14,
    color: "#666",
    textAlign: "center",
    lineHeight: 20,
  },
  actions: {
    alignItems: "center",
  },
  button: {
    borderRadius: 12,
    paddingHorizontal: 32,
    paddingVertical: 8,
  },
  buttonText: {
    fontSize: 16,
    fontWeight: "600",
  },
});
